/**
 * 9-box trait rating row. Color gradient red (1) → amber → green (9).
 * onChange(score) — toggles to 0 if same value clicked.
 */
import { cn } from "@/lib/utils";

const COLORS = [
  "bg-rose-500/80 ring-rose-300/40",
  "bg-rose-400/80 ring-rose-300/40",
  "bg-orange-500/80 ring-orange-300/40",
  "bg-amber-500/80 ring-amber-300/40",
  "bg-amber-400/80 ring-amber-300/40",
  "bg-yellow-400/80 ring-yellow-300/40",
  "bg-lime-400/80 ring-lime-300/40",
  "bg-emerald-400/80 ring-emerald-300/40",
  "bg-emerald-300/95 ring-emerald-200/60",
];

export function TraitBoxes({ value = 0, onChange, readOnly = false, testId }) {
  return (
    <div className="flex items-center gap-1" data-testid={testId}>
      {Array.from({ length: 9 }, (_, i) => i + 1).map((n) => {
        const filled = n <= (value || 0);
        const color = COLORS[n - 1];
        const isCurrent = n === (value || 0);
        return (
          <button
            key={n}
            type="button"
            disabled={readOnly}
            onClick={() => onChange?.(value === n ? 0 : n)}
            data-testid={testId ? `${testId}-box-${n}` : undefined}
            className={cn(
              "h-5 w-5 sm:h-[22px] sm:w-[22px] rounded-[5px] text-[9px] sm:text-[10px] font-mono font-semibold ring-1 transition-all",
              filled
                ? `${color} text-[#04111A] shadow-[0_0_6px_rgba(34,211,238,0.16)]`
                : "bg-white/[0.04] text-white/40 ring-white/10 hover:bg-white/[0.08]",
              isCurrent && "scale-110",
              readOnly && "cursor-default"
            )}
            aria-label={`Score ${n}`}
          >
            {n}
          </button>
        );
      })}
      <div className="ml-2 text-2 text-xs font-mono w-8 text-right">{value || "–"}</div>
    </div>
  );
}
